import type { IApplicationInfo } from '~/types/application-info'

import config from '~/config'
import { request } from '~/utils/request'

export const getApplicationMetadata = (appKey?: string): Promise<IApplicationInfo> => {
  return request({
    url: `${config.APP_USER_API}/application/${appKey}`,
  })
}
